import {
    addToLocalStorage,
    getValueFromLocalStorage
} from '@naturehouse/nh-essentials/lib/localStorage/localStorage';

export const USER_AVAILABLE_CLASSNAME = 'userAvailable';

export const USER_IS_LANDLORD_CLASSNAME = 'userIsLandlord';

export class UserStateStore {
    private readonly IS_LANDLORD_KEY: string = 'll';

    private readonly IS_LOGGED_IN: string = 'li';

    public constructor() {
        window.addEventListener('storage', this.#handleStorageEvent);
    }

    get isLandlord(): boolean {
        return getValueFromLocalStorage(this.IS_LANDLORD_KEY) === 'true';
    }

    set isLandlord(value: boolean) {
        addToLocalStorage(this.IS_LANDLORD_KEY, value.toString());
        this.#setIsLandlordClassName();
    }

    get isLoggedIn(): boolean {
        return getValueFromLocalStorage(this.IS_LOGGED_IN) === 'true';
    }

    set isLoggedIn(value: boolean) {
        addToLocalStorage(this.IS_LOGGED_IN, value.toString());
        this.#setIsUserClassName();
    }

    public resetState(): void {
        this.isLandlord = false;
        this.isLoggedIn = false;
    }

    #setIsLandlordClassName(): void {
        document.body.classList.toggle(USER_IS_LANDLORD_CLASSNAME, this.isLandlord);
    }

    #setIsUserClassName(): void {
        document.body.classList.toggle(USER_AVAILABLE_CLASSNAME, this.isLoggedIn);
    }

    readonly #handleStorageEvent = (event: StorageEvent): void => {
        if (event.key === this.IS_LANDLORD_KEY) {
            this.#setIsLandlordClassName();
        }

        if (event.key === this.IS_LOGGED_IN) {
            this.#setIsUserClassName();
        }
    };
}

export default new UserStateStore();
